import React, { useContext } from "react";
import "./Departments_available.css";
import Common_subHeading from "../../../common_components/common_subHeading/Common_subHeading";
import Pink_box from "../../../common_components/pink_box/Pink_box";
import { Context } from "../../../../utils/context";

function Departments_available({ data }) {

  const {language} = useContext(Context);
  return (
    <>
      <section className="Departments_available">
        <div className="container">
          {/* <Common_subHeading subHeading="Departments Available" /> */}

          <Common_subHeading subHeading={language == 1 ? "Departments Available" : "Départements disponibles"} />

          <div className="pink_box_holder">
            <div className="row">
              {data?.length > 0 ? (
                data?.map((item, index) => (
                  <div
                    className="col-xl-2 col-lg-3 col-md-3 col-sm-6 mb-4"
                    key={index}
                  >
                    <Pink_box
                      box_text={item?.WebDepartmentAvailable_Lang?.name}
                    />
                  </div>
                ))
              ) : (
                <div className="text-center">No Data Found</div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Departments_available;
